export default __webpack_public_path__ + "static/mistake-3-fd48c44f07bfba42ab205be438905ec2.png";